import BulkInquiry from "@/components/BulkInquiry";

const BulkInquiryPage = () => (
  <div data-testid="bulk-inquiry-page" className="mx-auto max-w-4xl px-4 pb-24 pt-40 sm:px-6">
    <p className="font-mono text-xs uppercase tracking-[0.4em] text-brand-yellow">
      Business Printing & Events
    </p>
    <h1 className="mt-2 font-display text-4xl font-black uppercase tracking-tight text-white sm:text-6xl">
      Quick Order / Bulk Inquiry
    </h1>
    <p className="mt-4 max-w-xl text-sm leading-relaxed text-zinc-400">
      Volume pricing on business cards, flyers, merch packs and event bundles. Send the spec —
      our production team returns a quote within one business day.
    </p>
    <div className="mt-10 border border-white/10 bg-ink-2 p-6 sm:p-8">
      <BulkInquiry />
    </div>
  </div>
);

export default BulkInquiryPage;
